import { render, staticRenderFns } from "./WebsiteTermsOfUse.vue?vue&type=template&id=361576f0&scoped=true&lang=pug&"
import script from "./WebsiteTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./WebsiteTermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteTermsOfUse.vue?vue&type=style&index=0&id=361576f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361576f0",
  null
  
)

export default component.exports